// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__WGmBE","modal":"Modal_modal__1OeQn","slide-down":"Modal_slide-down__1kMmf"};